import React from 'react';
import './Pelotita.css';

export default function Pelotita({ animation, playing, onPlay, onStop }) {
  const breathing = ['slow-breathing', 'normal-breathing'].includes(animation) ? animation : '';
  return <div id="circle">
    <div id="inner-circle" className={playing ? breathing : ''} aria-hidden="true" />
    <button id="circle-text" type="button" aria-label={playing ? 'Stop meditation' : 'Start meditation'}
      onClick={playing ? onStop : onPlay}>
      <span aria-hidden="true">{playing ? '■' : '▶'}</span>
    </button>
  </div>;
}
